import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { pdfColors, pdfFontSize, pdfLetter, pdfSpacing } from '../../../utils/pdf';

export interface GradeTile {
  label: string;
  value: number;
  color: string;
}

const styles = StyleSheet.create({
  summary: {
    flexDirection: 'row', alignItems: 'stretch', marginBottom: pdfSpacing.md,
    borderWidth: 0.6, borderColor: pdfColors.divider, borderStyle: 'solid', borderRadius: 4,
    backgroundColor: pdfColors.surfaceSoft,
  },
  average: { width: 118, paddingVertical: 8, paddingHorizontal: 12, borderRightWidth: 0.6, borderRightColor: pdfColors.divider, borderRightStyle: 'solid', justifyContent: 'center' },
  label: { fontSize: pdfFontSize.xxs, fontWeight: 600, textTransform: 'uppercase', letterSpacing: pdfLetter.openLabel, color: pdfColors.textMuted },
  averageValue: { fontSize: 15, fontWeight: 700, marginTop: 2 },
  tiles: { flex: 1, flexDirection: 'row', alignItems: 'center', paddingHorizontal: 6 },
  tile: { flex: 1, alignItems: 'center', paddingVertical: 6 },
  tileLabel: { fontSize: 7, color: pdfColors.textMuted, fontWeight: 500 },
  tileValue: { fontSize: 11, fontWeight: 700, marginTop: 2 },
});

/**
 * The class average beside how the grades fell — one tile per grade (and
 * whatever else is counted, like the absent), each in its grade's colour,
 * an empty grade greyed. Heads a marks report and a gradesheet alike.
 */
const GradeSummary: React.FC<{ average: number | null; averageColor?: string; tiles: GradeTile[] }> = ({ average, averageColor, tiles }) => (
  <View style={styles.summary} wrap={false}>
    <View style={styles.average}>
      <Text style={styles.label}>Class average</Text>
      <Text style={[styles.averageValue, { color: averageColor ?? pdfColors.textPrimary }]}>{average == null ? '—' : `${average.toFixed(1)}%`}</Text>
    </View>
    <View style={styles.tiles}>
      {tiles.map(t => (
        <View key={t.label} style={styles.tile}>
          <Text style={styles.tileLabel}>{t.label}</Text>
          <Text style={[styles.tileValue, { color: t.value ? t.color : pdfColors.dividerStrong }]}>{t.value}</Text>
        </View>
      ))}
    </View>
  </View>
);

export default GradeSummary;
